import { render, staticRenderFns } from "./RateView.vue?vue&type=template&id=6483073f&functional=true"
var script = {}
import style0 from "./RateView.vue?vue&type=style&index=0&id=6483073f&prod&lang=stylus&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  injectStyles,
  null,
  null
  
)

export default component.exports